import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import store from './store'	
//import Init from './containers/Init';
import Router from './components/Router';

import * as storage from './storage';
storage.firebase2()
ReactDOM.render(
	<Provider store={store}>
		<Router/>
	</Provider>,
	document.getElementById('root')
)


// WEBPACK FOOTER //
// ./src/index.js